<template>
  <div>
    <b-card class="border-none">
      <modal :show.sync="editModal" header-classes="bg-primary p-3">
        <h6 slot="header" class="modal-title text-white font-semibold pt-1">
          EDIT IMAGE ORDER
        </h6>
        <!-- <AddPageDetail /> -->
        <template slot="footer">
          <base-button type="primary">SAVE CHANGES</base-button>
          <base-button
            type="secondary"
            class="ml-auto"
            @click="editModal = false"
            >CLOSE</base-button
          >
        </template>
      </modal>
      <b-modal id="modal-2222" title="Edit Team" hide-footer>
        <EditAbout :editData="selectEditAboutUs" @close="closeModal" />
      </b-modal>

      <div class="flex justify-between items-center mb-8">
        <div>
          <h2 class="text-2xl font-semibold">About us</h2>

          <!-- <small class=" text-muted "
            >Lorem ipsum dolor sit amet, consectetur adipiscing elit,
          </small> -->
        </div>
        <div class="flex">
          <base-button
            outline
            class="px-6 py-1 mx-1"
            type="primary"
            v-b-modal.modal-22
          >
            <span class="btn-inner--text flex justify-between items-center"
              ><feather-icon icon="PlusIcon" class="cust-HW"></feather-icon
              >Team</span
            >
          </base-button>
          <b-modal id="modal-22" title="Add Team" hide-footer>
            <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
              <b-form role="form" @submit.prevent="handleSubmit(onAddSubmit)">
                <div>
                  <div class="mt-4 mb-4">
                    <FileUploader
                      v-show="!image"
                      :image="image"
                      :onSuccess="handleSuccess"
                      class="rounded-full widtht30percent m-auto display-none custmodal"
                    />
                    <img
                      v-if="image"
                      :src="image"
                      ref="cover"
                      class="rounded-full widtht30percent m-auto display-none custmodal"
                    />
                    <div
                      class="text-center text-red"
                      v-if="image"
                      @click="handleRemove"
                    >
                      Remove image
                    </div>
                    <p class="text-center">Upload your cover photo</p>
                    <span v-if="imageErr" class="small text-danger">{{
                      msg.image
                    }}</span>
                  </div>

                  <b-form-group
                    id="input-group-3"
                    label="Select Category"
                    label-for="input-3"
                  >
                    <b-form-select
                      id="input-3"
                      v-model="selectedCategory"
                      :options="categoryOption"
                      required
                    ></b-form-select>
                  </b-form-group>

                  <b-form-group label="Name">
                    <base-input
                      :rules="{
                        required: true,
                        alpha_spaces: true,
                      }"
                      v-model="name"
                      placeholder="name"
                      name="name"
                    ></base-input>
                  </b-form-group>
                  <b-form-group label="Designation">
                    <base-input
                      :rules="{
                        required: true,
                      }"
                      v-model="designation"
                      placeholder="Enter designation name"
                      name="designation"
                    ></base-input>
                  </b-form-group>
                  <b-form-group label="Description">
                    <base-input
                      :rules="{
                        required: true,
                      }"
                      v-model="description"
                      placeholder="Enter description name"
                      name="description"
                    ></base-input>
                  </b-form-group>
                  <b-form-group label="LinkedIn URL">
                    <!-- required -->
                    <base-input
                      v-model="linkedIn"
                      placeholder="URL"
                      name="linkedIn"
                      type="url"
                      :rules="{
                        regex:
                          '(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}(\.[a-zA-Z0-9]{2,})?',
                      }"
                    ></base-input>
                    <!-- <span v-if="linkErr" class="small text-danger">{{
                      msg.link
                    }}</span> -->
                  </b-form-group>

                  <div class="flex justify-center mt-2">
                    <b-button type="submit" variant="primary">Add</b-button>
                  </div>
                </div>
              </b-form>
            </validation-observer>
          </b-modal>
          <div></div>
        </div>
      </div>
      <!-- SearchBar -->
      <b-input-group class="mt-12">
        <b-form-input
          class="border-none shadow-lg"
          type="text"
          v-model="search"
          placeholder="Enter Search...."
        ></b-form-input>

        <b-input-group-append>
          <b-button
            variant="white"
            class="flex items-center shadow-lg"
            aria-label="search"
          >
            <feather-icon
              class="cursor-pointer mr-2"
              icon="SearchIcon"
              svgClasses="w-4 h-4"
            ></feather-icon>
          </b-button>
        </b-input-group-append>
      </b-input-group>

      <!-- table -->
      <el-table :data="tableData" style="width: 100%" border class="mt-4">
        <el-table-column prop="category" label="Pages" width="100">
        </el-table-column>
        <el-table-column prop="image" label="Images" width="">
          <template slot-scope="scope">
            <img
              :src="
                scope.row.image
                  ? `${$imageURL}/${scope.row.image}`
                  : require(`@/assets/images/AuthorImage.jpg`)
              "
              class="w-20 h-20"
              :alt="scope.row.name"
            />
          </template>
        </el-table-column>
        <el-table-column prop="name" label="Name" width=""> </el-table-column>
        <el-table-column prop="designation" label="Designation" width="">
          <template slot-scope="scope">
            {{ scope.row.designation ? scope.row.designation : "-" }}
          </template>
        </el-table-column>
        <el-table-column prop="description" label="Description" width="">
          <template slot-scope="scope">
            <div v-html="scope.row.description" class="ellipsis-3"></div>
          </template>
        </el-table-column>
        <el-table-column label="Edited By" prop="editedby" sortable>
          <template slot-scope="scope">
            <p
              class="font-semibold text-left name mb-0 text-sm"
              v-if="scope.row.isEdited"
            >
              {{
                scope.row.editedByName[0].firstname +
                  " " +
                  scope.row.editedByName[0].lastname || " "
              }}
            </p>
          </template>
        </el-table-column>
        <el-table-column prop="action" label="Action" width="100">
          <template slot-scope="scope">
            <div class="flex items-center">
              <feather-icon
                @click="handleEditAboutUs(scope.row)"
                icon="EditIcon"
                svgClasses="w-5 h-5"
                class="cursor-pointer text-primary"
                v-b-modal.modal-2222
              />
              <div class="flex" @click="handleDeleteAboutUs(scope.row._id)">
                <feather-icon
                  svgClasses="w-5 h-5"
                  class="ml-2 cursor-pointer text-danger"
                  icon="Trash2Icon"
                />
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <b-card-footer class="py-4 d-flex justify-content-end">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          aria-controls="my-table"
        ></b-pagination>
      </b-card-footer>
    </b-card>
  </div>
</template>
<script>
// import "../../scss/Index.scss";
import EditAbout from "./component/EditAbout.vue";

import { mapState } from "vuex";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";
import FileUploader from "../../../../../components/FileUploader.vue";
export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    EditAbout,

    FileUploader,
  },
  data() {
    return {
      drawer: false,
      Data: "",
      edit: "",
      editModal: false,
      openAddBannerSidebar: false,
      approve: false,

      categoryOption: [
        { text: "Select One", value: null },
        { text: "Team", value: "team" },
        { text: "Mentor", value: "mentor" },
        { text: "Advisor", value: "advisor" },
        { text: "Board Members", value: "board members" },
      ],
      name: "",
      designation: "",
      description: "",
      selectedCategory: null,
      linkedIn: "",
      image: null,
      coverImage: null,

      selectEditAboutUs: {},
      search: "",
      totalRows: 0,
      perPage: 5,
      currentPage: 1,
      tableData: [
        // {
        //   image: "2016-05-03",
        //   name: "Tom",
        //   linkedIn: "test",
        //   category: "test",
        //   description: "No. 189, Grove St, Los Angeles",
        //   designation: "manager",
        // },
      ],
      nameErr: false,
      imageErr: false,
      linkErr: false,
      msg: {},
    };
  },
  watch: {
    search: {
      handler: _.debounce(async function (val) {
        this.getAboutUs();
      }, 500),
    },
    async currentPage() {
      await this.getAboutUs();
    },
  },
  methods: {
    // handleAddAuthor(val = false, item = {}) {
    //   this.isAddtestActive = val;
    //   this.selectaddAuthor = item;
    // },
    handleEditAboutUs(item = {}) {
      this.selectEditAboutUs = item;
    },
    handleSuccess(image) {
      let mByte = 5 * 1048576;
      if (image.size > mByte) {
        this.$swal.fire({
          title: "File size exceeds the allowed limit!",
          // text: "Please ensure that the file size does not exceed 5MB",
          html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
          confirmButtonText: "Okay",
          icon: "warning",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        return;
      }
      this.imageErr = false;
      if (image.type.includes("video")) {
        this.imageErr = true;
        this.msg.image = "Upload Image Only";
      } else {
        this.imageErr = false;

        this.coverImage = image;
        this.readerData(image);
      }
    },
    readerData(rawFile) {
      let loader = this.$loading();

      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));

        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },
    async onAddSubmit() {
      if (this.coverImage === null) {
        this.$swal({
          text: "Please Add Image",
          // icon: "success",
          showCancelButton: false,
          confirmButtonColor: "#830c81",
        });
        return;
      }
      // if(!this.linkedIn){
      //   return false
      // }
      this.name = this.name.trim();
      this.designation = this.designation.trim();
      this.description = this.description.trim();
      this.selectedCategory = this.selectedCategory.trim();
      this.linkedIn = this.linkedIn.trim();

      const payload = new FormData();
      payload.append("name", this.name);

      if (this.designation) payload.append("designation", this.designation);
      if (this.description) payload.append("description", this.description);
      if (this.selectedCategory)
        payload.append("category", this.selectedCategory);
      if (this.linkedIn) payload.append("linkedIn", this.linkedIn);
      if (this.coverImage) payload.append("image", this.coverImage);

      let loader;

      try {
        // console.log(payload);
        loader = this.$loading();

        const createAboutUs = await this.$store.dispatch(
          "aboutUs/createAboutUs",
          payload
        );

        if (createAboutUs.code === 200) {
          // console.log(createAuthor);
          this.$bvModal.hide("modal-22");
          loader.close();
          await this.$swal({
            text: `Profile has been successfully added!`,
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#830c81",
          });

          this.name = "";
          this.designation = "";
          this.description = "";
          this.linkedIn = "";
          this.coverImage = null;
          this.selectedCategory = null;
          this.image = null;
          this.getAboutUs();
        }

        loader.close();
      } catch (error) {
        loader.close();
        console.log(error);
      }
    },
    handleRemove() {
      this.image = null;
      this.coverImage = null;
    },
    async handleDeleteAboutUs(data) {
      const result = await this.deleteAlert();
      if (result.isConfirmed) {
        this.deleteData(data);
      }
    },
    deleteAlert() {
      return this.$swal({
        title: "Are you sure?",
        html: `You won't be able to revert this!</p>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#830c81",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });
    },
    async deleteData(id) {
      let loader;
      let payload = {
        aboutUsId: id,
      };
      loader = this.$loading();
      try {
        const data = await this.$store.dispatch(
          "aboutUs/deleteAboutUs",
          payload
        );
        loader.close();
        if (data.code === 200) {
          await this.$swal({
            text: `Profile has been successfully deleted!`,
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#830c81",
          });
          this.getAboutUs();
        }
      } catch (err) {
        console.log(err);
        loader.close();
      }
    },
    async getAboutUs() {
      let curPage = this.currentPage - 1;
      let payload = {
        limit: this.perPage,
        offset: curPage,
      };
      let loader;
      if (this.search !== "")
        Object.assign(payload, { search: this.search.trim() });

      try {
        loader = this.$loading();
        const getAboutUs = await this.$store.dispatch(
          "aboutUs/getAboutUs",
          payload
        );
        // console.log(getAuthor);
        loader.close();
        this.totalRows = this.aboutUs.totalCount;
        let aboutUsData = this.aboutUs.result;
        this.tableData = aboutUsData;
      } catch (error) {
        console.log(error);
        loader.close();
      }
    },
    async closeModal() {
      // this.$emit("close");
      this.$bvModal.hide("modal-2222");
      await this.getAboutUs();
    },
    handleName() {
      this.nameErr = false;
      if (!/^[a-zA-Z]+$/.test(this.name)) {
        this.nameErr = true;
        this.msg.name = "Name should not be numeric value";
      }
    },
  },
  async mounted() {
    await this.getAboutUs();
  },

  computed: {
    ...mapState("aboutUs", {
      aboutUs: "aboutUs",
    }),
  },
};
</script>
<style>
.modal-header {
  display: flex !important;
  align-items: center !important;
  background-color: #4f0a4b !important;
  border-color: #4f0a4b !important;
  padding: 1rem !important;
}
.modal-title {
  font-size: 20px !important;
  color: #fff !important;
}
.widtht30percent {
  width: 30%;
  height: 140px !important;
}

.form-group {
  margin-bottom: 0.5rem;
}
</style>
